import _extends from "@babel/runtime/helpers/extends";
var _TrustpilotStarWhite;
import React from 'react';
import styled from 'styled-components';
import { Li, Ul } from '../../Typography';
import SvgIcon from '../../SvgIcon';
import TrustpilotStarWhite from '@tourlane/iconography/Icons/Trustpilot/TrustpilotStarWhite';
import { size } from '../../style/size';
const TRUSTPILOT_1_STAR_COLOR = '#ff3722';
const TRUSTPILOT_2_STAR_COLOR = '#ff8622';
const TRUSTPILOT_3_STAR_COLOR = '#ffce00';
const TRUSTPILOT_4_STAR_COLOR = '#73cf11';
const TRUSTPILOT_5_STAR_COLOR = '#00b67a';
const TRUSTPILOT_DISABLED_COLOR = '#dcdce6';
const getStarColor = number => {
  if (number > 4) {
    return TRUSTPILOT_5_STAR_COLOR;
  } else if (number > 3) {
    return TRUSTPILOT_4_STAR_COLOR;
  } else if (number > 2) {
    return TRUSTPILOT_3_STAR_COLOR;
  } else if (number > 1) {
    return TRUSTPILOT_2_STAR_COLOR;
  } else {
    return TRUSTPILOT_1_STAR_COLOR;
  }
};
const StarDisabledContainer = styled.div`
  position: relative;
  background-color: ${TRUSTPILOT_DISABLED_COLOR};
  ${({
  size: value
}) => size(value)}
`;
const StarActiveProgress = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${({
  percent
}) => Math.round(Math.max(Math.min(percent, 1), 0) * 100)}%;
  background-color: ${({
  number
}) => getStarColor(number)};
`;
const StarIcon = styled(SvgIcon)`
  position: absolute;
  top: 0;
  left: 0;
`;
const TrustpilotStars = ({
  number = 5,
  starSize,
  starMargin,
  ...props
}) => {
  var _StarIcon;
  return /*#__PURE__*/React.createElement(Ul, _extends({
    inline: true,
    noWrap: true,
    horizontalOffset: starMargin
  }, props), Array(5).fill(undefined).map((v, idx) => /*#__PURE__*/React.createElement(Li, {
    key: idx
  }, /*#__PURE__*/React.createElement(StarDisabledContainer, {
    size: starSize
  }, /*#__PURE__*/React.createElement(StarActiveProgress, {
    percent: number - idx,
    number: number
  }), _StarIcon || (_StarIcon = /*#__PURE__*/React.createElement(StarIcon, {
    color: null,
    size: starSize
  }, _TrustpilotStarWhite || (_TrustpilotStarWhite = /*#__PURE__*/React.createElement(TrustpilotStarWhite, null))))))));
};
export default TrustpilotStars;